import React, { Fragment } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Email from "./pages/ResetPassword/Email";
import Login from "./pages/Login";
import PatientPage from "./pages/PatientPage";
import EncountersPage from "./pages/EncountersPage";
import ResetPassword from "./pages/ResetPassword/ResetPassword";
import UserProfile from "./pages/UserProfile";
import Notifications from "./pages/Notifications";
import CodeApprovalsPage from "./pages/CodeApprovalsPage";
import CampaignsPage from "./pages/CampaignsPage";
import AllCodersPage from "./pages/AllCodersPage";
import LeaderBoardPage from "./pages/LeaderBoardPage";
import Welcome from "./pages/Welcome";
import Registration from "./pages/Registration";
import { BackendContext } from "./utils/BackendContext";
/*this context allows any component to reference one backend object
  https://reactjs.org/docs/context.html/ */
//TODO: switch via npm script flag
import DevBackend from "./utils/DevBackend.ts";
import { createContext, useEffect, useState, useMemo } from "react";
export const RoleContext = createContext(null);
const backend = new DevBackend();

function App() {
  const [role, setRole] = useState("");
  const [user, setUser] = useState({});

  const userRole = useMemo(() => ({ role, setRole }), [role, setRole]);


  const userInfo = JSON.parse(localStorage.getItem('userInfo'));

  useEffect(() => {
    if (Object.keys(user).length === 0) {
      setUser(userInfo);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const unauthenticatedRoutes = (
    <Fragment>
      <Route exact path="/" element={<Welcome />} />
      <Route exact path="/login" element={<Login />} />
      <Route exact path="/login/confirm-email" element={<Email />} />
      <Route exact path="/login/reset-password" element={<ResetPassword />} />
      <Route exact path="/welcome" element={<Welcome />} />
      <Route exact path="/registration" element={<Registration />} />
    </Fragment>
  );

  const authenticatedRoutes = (
    <Fragment>
      <Route exact path="/code-approvals" element={<CodeApprovalsPage />} />
      <Route exact path="/encounters" element={<EncountersPage />} />
      <Route exact path="/notifications" element={<Notifications />} />
      <Route exact path="/leaderboard" element={<LeaderBoardPage />} />
      <Route exact path="/campaigns" element={<CampaignsPage />} />
      <Route exact path="/all-coders" element={<AllCodersPage />} />
      <Route exact path="/profile" element={<UserProfile user={user} />} />
      <Route exact path="/" element={<PatientPage />} />
    </Fragment>
  );

  return (
    <BackendContext.Provider value={backend}>
      <div className="App">
        <BrowserRouter>
          <RoleContext.Provider value={userRole}>
            <Routes>
              {userInfo !== null ? authenticatedRoutes : unauthenticatedRoutes }
            </Routes>
          </RoleContext.Provider>
        </BrowserRouter>
      </div>
    </BackendContext.Provider>
  );
}

export default App;
